import Page from 'components/layout/Page';
import ConsultancyFeatures from './sections/features/ConsultancyFeatures';
import Form from './sections/form/Form';
import ConsultancyHero from './sections/hero/ConsultancyHero';
import ConsultancyCases from './sections/services/ConsultancyCases';
import { CaseItem } from './ConsultancyComponent.types';
import ConsultancyCta from './sections/cta/ConsultancyCta';

type ContentProps = {
  cases: CaseItem[];
};

const ConsultancyComponent: React.FC<ContentProps> = ({ cases }) => {
  return (
    <Page pageVariant="midnight_light" hasScrollTop>
      <ConsultancyHero />
      <ConsultancyFeatures />
      <ConsultancyCases cases={cases} />
      <ConsultancyCta />
      <Form />
    </Page>
  );
};

export default ConsultancyComponent;
